import React, {useState, useEffect, useRef, useCallback, createRef} from "react";
import DataGrid, {
    Column,
    MasterDetail,
    Paging,
    SearchPanel,
    Export, Sorting, Pager, Summary, TotalItem
} from 'devextreme-react/data-grid';
import {FormContainer, LayoutChild} from "../../../../palette/Palette";
import HeaderPage from "../../../../palette/HeaderPage";
import axios from "axios";
import {inject, observer} from "mobx-react";
import format from "date-fns/format";
import DetailTemplate from "./DetailTemplate";
import {useSnackbar} from "notistack";
import ComponentLoadPanel from "../../../../palette/LoadPanel";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {jsPDF} from "jspdf";
import {exportDataGrid as exportDataGridToPdf} from "devextreme/pdf_exporter";
import ExcelJS from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import saveAs from 'file-saver';
import VerticalSpace from "../../../../palette/VerticalSpace";
import {Animated} from "react-animated-css";
import Alerts from "../../../../palette/Alerts";
import {LoadIndicator} from "devextreme-react/load-indicator";
import {es} from "date-fns/locale";

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

const url = 'https://collection-payments-easi4xatjq-uc.a.run.app/collection-payments';
//const url = 'http://127.0.0.1:5000/collection-payments';

const now = new Date();

const datesObject = {
    since: null,
    until: null
}

const Load = ({textLoad}) => {
    return (
        <div style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        }}>
            <LoadIndicator id="medium-indicator" height={40} width={40}/>
            <span style={{fontSize: 11, color: 'gray', marginTop: 5}}>{textLoad}</span>
        </div>
    )
}

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}


function CollectionsPayments(props) {

    const {DataStore} = props;

    const {companyName, idCompany} = DataStore

    const [loading, setLoading] = useState(false)
    const [trigger, setTrigger] = useState(false)
    const [master, setMaster] = useState(null)
    const [totalCompany, setTotalCompany] = useState(null)
    const [dates, setDates] = useState(datesObject);
    const [datesStr, setDatesStr] = useState(datesObject);
    const [showPanel, setShowPanel] = useState(false);
    const [empty, setEmpty] = useState(false);
    const [textGrid, setTextGrid] = useState('Esperando datos...');

    const {enqueueSnackbar} = useSnackbar();
    const isMounted = useMountedState()
    const dataGridRef = createRef();

    const month = format(new Date(), 'MMMM', {locale: es});
    const upperMonth = month.charAt(0).toUpperCase() + month.slice(1)

    useEffect(() => {
        const GetCollectionPayments = async () => {

            const date = format(now, 'yyyy-MM-dd')
            const search = {since: date, until: date}

            const data = {search, companyName, idCompany, sameYear: true, query: false}

            await axios.post(url, data, {headers: headers})
                .then(res => {
                    if (!res.data.empty) {
                        setLoading(true)
                        setEmpty(res.data.empty)
                        setMaster(res.data.master)
                        setTotalCompany(res.data.totalCompany)
                        DataStore.getPaymentsDetails(res.data.detail)
                        res.data.master?.length === 0 && setTextGrid('Aun no existen datos para este mes')
                        setLoading(true)
                    } else {
                        setLoading(true)
                        setEmpty(res.data.empty)
                    }
                })
        }
        if (isMounted()) {
            GetCollectionPayments().catch((e) => {
               // console.log(e)
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            })
        }
    }, [isMounted, trigger])

    const onValueChanged = async (value, key) => {
        if (value) {
            const date = format(value, 'yyyy-MM-dd')
            setDates({...dates, [key]: value})
            setDatesStr({...datesStr, [key]: date})
            const search = {...datesStr, [key]: date}

            if (search.until && search.since) {
                if (search.until < search.since) {
                    NotiStackInfo('La fecha final no puede ser anterior a la fecha actual', 'error',
                        enqueueSnackbar)
                    return
                }

                setShowPanel(true)

                const dateSince = Date.parse(search.since)
                const dateUntil = Date.parse(search.until)

                const yearSince = format(dateSince, 'yyyy')
                const yearUntil = format(dateUntil, 'yyyy')

                if (yearSince === yearUntil) {
                    const data = {
                        search,
                        companyName: companyName,
                        idCompany: idCompany,
                        sameYear: true,
                        query: true
                    }


                    await axios.post(url, data, {headers: headers})
                        .then(res => {
                            setMaster(res.data.master)
                            setTotalCompany(res.data.totalCompany)
                            res.data.master?.length === 0 && setTextGrid('No existen datos en este rango de fechas')
                            DataStore.getPaymentsDetails(res.data.detail)
                            setShowPanel(false)
                        }).catch((e) => {
                            setMaster([])
                            setShowPanel(false)
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                        })

                } else {
                    const data = {
                        search,
                        companyName: companyName,
                        idCompany: idCompany,
                        sameYear: false,
                        query: true
                    }

                    await axios.post(url, data, {headers: headers})
                        .then(res => {
                            setMaster(res.data.master)
                            res.data.master?.length === 0 && setTextGrid('No existen datos en este rango de fechas')
                            DataStore.getPaymentsDetails(res.data.detail)
                            setShowPanel(false)
                        }).catch((e) => {
                           // console.log(e)
                            setMaster([])
                            setShowPanel(false)
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                        })
                }
            }
        }
        if (value == null) {
            setTrigger(!trigger)
            setDates(datesObject)
        }
    }

    const onToolbarPreparing = (e) => {

        const {toolbarOptions} = e
        const {items} = toolbarOptions

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                width: 120,
                text: 'Imprimir',
                elementAttr: {id: 'btn-pdf'},
                icon: 'far fa-file-pdf',
                onClick: exportGridPDF
            }
        })

        items.unshift({
                location: 'before',
                widget: 'dxDateBox',
                options: {
                    width: 212,
                    placeholder: 'Hasta',
                    showClearButton: true,
                    value: dates.until,
                    onValueChanged: (e) => onValueChanged(e.value, 'until')
                }
            },
        )

        items.unshift({
                location: 'before',
                widget: 'dxDateBox',
                options: {
                    width: 212,
                    placeholder: 'Desde',
                    showClearButton: true,
                    value: dates.since,
                    onValueChanged: (e) => onValueChanged(e.value, 'since')
                }
            },
        )
    }

    function exportGridPDF() {
        const pdfDoc = new jsPDF('l', 'pt', "a4");
        const dataGrid = dataGridRef.current.instance;

        const options = {
            jsPDFDocument: pdfDoc,
            component: dataGrid,
            autoTableOptions: {
                margin: {top: 60, left: 15}
            },
        }

        exportDataGridToPdf(options).then(() => {
            pdfDoc.setFontSize(12);
            const pageCount = pdfDoc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdfDoc.setPage(i);
                const pageSize = pdfDoc.internal.pageSize;
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const header = companyName;
                const report = `Reporte : Cobros y pagos`
                const date = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`
                const footer = `Pagina ${i} de ${pageCount}`;

                // Header
                pdfDoc.setFontSize(14)
                pdfDoc.setFont('helvetica', '', 'bold')
                pdfDoc.text(header, 15, 15, {baseline: 'top'});
                pdfDoc.setFontSize(12)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(report, 15, 30, {baseline: 'top'});
                pdfDoc.setFontSize(8)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(date, 15, 45, {baseline: 'top'});
                // Footer
                pdfDoc.setFontSize(8)
                pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, {baseline: 'bottom'});

            }
        }).then(() => {
            pdfDoc.save('Cobros-pagos.pdf');
        });
    }

    const onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            topLeftCell: {row: 6, column: 2},
            customizeCell: ({gridCell, excelCell}) => {

                if (gridCell.rowType === 'data') {
                    if (excelCell.row % 2 === 0) {
                        excelCell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: 'C6EFCE'},
                            bgColor: {argb: 'C6EFCE'},
                        };
                    }
                }
            },
        }).then(function () {
            const headerCompany = worksheet.getRow(2);
            const headerReport = worksheet.getRow(3);
            const headerDate = worksheet.getRow(4);

            headerCompany.getCell(2).value = companyName;
            headerCompany.getCell(2).font = {bold: true, size: 16, underline: 'double'};

            headerReport.getCell(2).value = `Reporte : Cobros y pagos`;
            headerReport.getCell(2).font = {name: 'Segoe UI Light', size: 12, bold: 600};
            headerReport.getCell(2).alignment = {horizontal: 'left'};

            headerDate.getCell(2).value = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`;
            headerDate.getCell(2).font = {name: 'Segoe UI Light', size: 8, bold: 700};
            headerDate.getCell(2).alignment = {horizontal: 'left'};

            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'Cobros-pagos.xlsx');
            });
        });
        e.cancel = true;
    };

    return (
        <>
            <VerticalSpace space={30}/>
            {(master === null && !empty) ? <Load textLoad={'Cargando...'}/> :
                <>
                    <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                        <div className="grid-container">
                            <HeaderPage icon={'fas fa-money-check-alt'} text={'Cobros y pagos'} load={loading}
                                        textLoad={'Cargando....'}/>
                            <FormContainer>
                                <DataGrid
                                    id="types-vehicles"
                                    ref={dataGridRef}
                                    dataSource={master}
                                    keyExpr="ID"
                                    noDataText={textGrid}
                                    onToolbarPreparing={onToolbarPreparing}
                                    onExporting={onExporting}
                                    showBorders={true}
                                >
                                    <SearchPanel visible={true}
                                                 width={240}
                                                 placeholder="Buscar"/>
                                    <Export enabled={true} texts={{exportAll: 'Excel'}}/>
                                    <Sorting mode="multiple"/>
                                    <Paging defaultPageSize={20}/>
                                    <Pager
                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 20, 30]}
                                        showInfo={true}/>
                                    />
                                    <Column dataField="driver" alignment={'center'} caption="Conductor"/>
                                    <Column dataField="totalTrips" alignment={'center'} caption="Núm. de viajes"/>
                                    <Column dataField="numberPassengers" alignment={'center'}
                                            caption="Número de pasajeros"/>
                                    <Column dataField="parcels" alignment={'center'} caption="Número de encomiendas"/>
                                    <MasterDetail
                                        enabled={true}
                                        component={DetailTemplate}
                                    />
                                    <SearchPanel visible={true}
                                                 width={240}
                                                 placeholder="Buscar"/>
                                    <Export enabled={true} texts={{exportAll: 'Excel'}}/>
                                    <Sorting mode="multiple"/>
                                    <Paging defaultPageSize={15}/>
                                    <Pager
                                        showPageSizeSelector={true}
                                        allowedPageSizes={[5, 10, 20]}
                                        showInfo={true}/>

                                    <Summary>

                                        <TotalItem
                                            showInColumn="driver"
                                            displayFormat={`Total : $ ${totalCompany?.valueCollect}`}
                                        />

                                        <TotalItem
                                            showInColumn="totalTrips"
                                            displayFormat={`Valor a pagar : $ ${totalCompany?.amountPaid}`}
                                        />

                                        <TotalItem
                                            showInColumn="numberPassengers"
                                            displayFormat={`Comisión tarjeta : $ ${totalCompany?.cardCommission}`}
                                        />

                                        <TotalItem
                                            showInColumn="parcels"
                                            displayFormat={`Neto para la empresa : $ ${totalCompany?.netCompany}`}
                                        />
                                    </Summary>

                                </DataGrid>
                            </FormContainer>
                        </div>
                    </Animated>
                    <ComponentLoadPanel showLoadPanel={showPanel} message={'Consultando. . .'} time={3000}/>
                </>}
            {
                (empty && master === null) &&
                <LayoutChild color='transparent' percent={95} margin='auto' top={10}>
                    <Alerts severity='warning' body={`Aun no existen datos para el mes de ${upperMonth}`}/>
                </LayoutChild>
            }
        </>
    )
}

export default inject('DataStore', 'ControlStore')(observer(CollectionsPayments));
